const convertLevelType = (levelType: string): number => {
  switch (levelType) {
    case 'level0':
      return 0
    case 'level1':
      return 1
    case 'level2':
      return 2
    case 'level3':
      return 3
    default:
      return 4
  }
}

export default convertLevelType
